export default __webpack_public_path__ + "static/media/overview_current.fefd3f87.png";